<template>
  <div class="container">
    <h2>儲值/扣款紀錄</h2>
    <div class="search-box">
      <div class="form-group form-inline">
        <label for="search">搜尋呼號：</label>
        <input
          type="text"
          class="form-control"
          id="search"
          v-model="searchText"
          placeholder="隊編/呼號"
        />
      </div>
      <a href="#" class="btn btn-success" @click="search()">搜尋</a>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label" style="font-size: 20px">儲值紀錄</span>
        <div class="table-box">
          <table class="table-item" v-if="this.recordData.length">
            <div class="count">
              <label>顯示的筆數：</label>
              <select
                class="form-control"
                v-model="count"
                style="width: 15%"
                @change="changeNum(1)"
              >
                <option :value="25" selected>25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
            <thead>
              <th style="width: 25%">日期</th>
              <th style="width: 25%">呼號/姓名</th>
              <th style="width: 25%">儲值/退款金額</th>
              <th style="width: 25%">經手人</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in recordData" :key="index">
                <td>{{ transferDate(item.date) }}</td>
                <td>{{ item.driverCallNumber }} / {{ item.driverName }}</td>
                <td v-if="item.storedValueType == 0">
                  -${{ item.storedValueAmount }}(剩餘${{
                    item.storedValueBalance
                  }})
                </td>
                <td v-else>
                  ${{ item.storedValueAmount }}(剩餘${{
                    item.storedValueBalance
                  }})
                </td>
                <td>{{ item.teamManagerName }}</td>
              </tr>
            </tbody>
          </table>
          <h3 v-if="this.recordData.length == 0">無符合的資料</h3>
        </div>
        <nav aria-label="..." v-if="this.recordData.length">
          <paginate
            :page-count="paging.totalPages"
            :click-handler="getRecord"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :init-page="2"
            :container-class="'pagination'"
            :key="key"
          ></paginate>
        </nav>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label" style="font-size: 20px">扣款紀錄</span>
        <div class="table-box">
          <table class="table-item" v-if="this.deductData.length">
            <div class="count">
              <label>顯示的筆數：</label>
              <select
                class="form-control"
                v-model="dedcutCount"
                style="width: 15%"
                @change="changeNum(1)"
              >
                <option :value="25" selected>25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
            <thead>
              <th>日期</th>
              <th>種類</th>
              <th>派車單號</th>
              <th>呼號/姓名</th>
              <th>車資</th>
              <th>扣款金額</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in deductData" :key="index">
                <td>{{ transferDate(item.date) }}</td>
                <td>{{ item.orderType ? '預約單' : '一般單' }}</td>
                <td>{{ item.orderId }}</td>
                <td>{{ item.driverCallNumber }} / {{ item.driverName }}</td>
                <td>${{ item.actualPrice }}</td>
                <td>
                  ${{ item.storedValueDeductAmount }}(剩餘${{
                    item.storedValueDeductBalance
                  }})
                </td>
              </tr>
            </tbody>
          </table>
          <h3 v-if="this.deductData.length == 0">無符合的資料</h3>
          <nav aria-label="..." v-if="this.deductData.length">
            <paginate
              :page-count="deductPaging.totalPages"
              :click-handler="chargeback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :init-page="2"
              :container-class="'pagination'"
              :key="key"
            ></paginate>
          </nav>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import moment from 'moment'
import Paginate from 'vuejs-paginate'
import { cookies } from '@/utils/cookies'

export default {
  data() {
    return {
      recordData: [],
      paging: [],
      changePaging: [],
      option: false,
      count: 25,
      searchText: '',
      deductData: [],
      deductPaging: [],
      dedcutCount: 25,
      isSearch: false,
      key: 0,
      teamCodeCookie: cookies.get('GladTeamCode'),
    }
  },
  components: {
    Paginate,
  },
  methods: {
    async getRecord(page = 1) {
      if (!this.isSearch) {
        await API.get(
          `store_value/record/?per_page=${this.count}&current_page=${page}`,
        ).then((res) => {
          this.recordData = res.result.data
          this.paging = res.result.paging
        })
        return
      } else {
        await API.get(
          `store_value/record/?per_page=${this.count}&current_page=${page}&kw=${this.searchText}`,
        ).then((res) => {
          this.recordData = res.result.data
          this.paging = res.result.paging
        })
      }
    },
    async chargeback(page = 1) {
      if (!this.isSearch) {
        await API.get(
          `store_value/deduct?per_page=${this.dedcutCount}&current_page=${page}`,
        ).then((res) => {
          this.deductData = res.result.data
          this.deductPaging = res.result.paging
        })
        return
      } else {
        await API.get(
          `store_value/deduct?per_page=${this.dedcutCount}&current_page=${page}&kw=${this.searchText}`,
        ).then((res) => {
          this.deductData = res.result.data
          this.deductPaging = res.result.paging
        })
      }
    },
    async changeNum() {
      this.key += 1
      this.getRecord()
      this.chargeback()
    },
    search() {
      this.isSearch = true
      this.key += 1
      if (this.searchText === '') {
        this.isSearch = false
        this.getRecord()
        this.chargeback()
        this.count = 25
        this.dedcutCount = 25
        return
      } else {
        this.getRecord()
        this.chargeback()
      }
    },
    transferDate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.meta.title == '儲值/扣款紀錄') {
          this.$swal.close()
        }
      },
    },
  },
  created() {
    this.getRecord()
    this.chargeback()
  },
}
</script>

<style scoped lang="scss">
.container {
  padding: 0 15px;
}
h2 {
  font-size: 36px;
  margin: 36px 0;
  color: black;
  font-weight: bold;
}
a {
  margin-left: 12px;
  margin-bottom: 0px;
}
.search-box {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  label {
    font-size: 20px;
    margin-bottom: 0;
  }
}
.nav-tabs {
  border: none;
  margin-top: 60px;
  z-index: 2;
  & > li.active > a {
    background-color: rgb(213, 213, 213);
  }
}
.form-group {
  margin-bottom: 0;
}
.table-box {
  select {
    margin: 10px 0;
  }
  .count {
    display: flex;
    align-items: center;
  }
  .table-item {
    margin-top: 1px;
    padding: 20px 0;
    display: inline-block;
    border-radius: 5px;
    font-size: 16px;
    color: black;
    th {
      background-color: #405367;
      border: 1px solid black;
      color: white;
      padding: 20px 15px;
    }
    td {
      width: 1000px;
      border: 1px solid black;
      padding: 20px 15px;
    }
    tr {
      background-color: white;
    }
    tr:nth-child(odd) {
      background-color: #f9f9f9;
    }
  }
  h3 {
    margin-top: 50px;
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/stored/StoreRecord.vue